<template>
  <div
    class="search-result-card"
    :class="{tiered: provider.tieredLocation}">
    <div
      :id="provider.locationId"
      class="scroll-anchor">
    </div>
    <div
      v-if="!viewDetails"
      class="themed-strip"
      :style="provider.tieredLocation ? globalTheme.borderTieredMapMarker :
        (isValidTierName ? { borderColor: wholesaleProviderColor + ' !important' } :
          (isDiscountOptOut ? { borderColor: noDiscountProviderColor + ' !important' } : globalTheme.borderColor))" 
          />
    <div grid="row wrap stretch" class="_mbxs">
      <div
        column="xs-12 s-12 m-6"
        class="title-column">
        <button
          class="simple card-title-map-link"
          :aria-label=" viewDetails ? `${provider.businessName}` : `select ${provider.businessName} in map`"
          @click="setCurrentProvider"
          @keydown.enter="setCurrentProvider">
          <div
            :style="globalTheme.colorBlack"
            class="h3 name">
            <app-inline-svg
              v-if="!brandLogo() && !provider.tieredLocation"
              :style="(isValidTierName || isDiscountOptOut) ? { color: '#808080 !important' } : globalTheme.color"
              :src="icon"
              aria-label="map marker icon" />
            <template v-if="provider.tieredLocation">
              <div class="tiered-provider-logo flex-wrap --column">
                <img
                  v-if="brandLogo()"
                  class="brand-logo"
                  :style="(isValidTierName || isDiscountOptOut) ? { color: '#808080 !important' } : ''"
                  :src="brandLogo()"
                  :aria-label="provider.businessName">
                <span
                  v-else
                  class="tiered-brand-name"
                  :style="globalTheme.colorBlack">
                  {{provider.businessName}}
                </span>
              </div>
            </template>
            <template v-else>
              <img
                v-if="brandLogo()"
                class="brand-logo"
                :src="brandLogo()"
                :aria-label="provider.businessName">
              <template
                v-else>
                {{provider.businessName}}
              </template>
            </template>
            <font-awesome-icon
              :style="provider.tieredLocation ? globalTheme.colorTieredMapMarker :  ((isValidTierName || isDiscountOptOut) ? { color: '#808080 !important' } : globalTheme.color)"
              :icon="['fas', 'caret-up']"/>
          </div>
        </button>
        <div
          v-if="provider.tieredLocation || hasSpecialOffer || hasSpecialOfferIndependent"
          grid="row wrap baseline" class="offers-tag">
          <div
            v-if="provider.tieredLocation"
            column="xs-12 s-6">
            <tiered-provider-label :label="labels.tieredProviderLabel"/>
          </div>
          <div
            v-if="hasSpecialOffer"
            column="xs-12 s-6">
            <special-offer-label :label="labels.specialOfferLabel"/>
          </div>
          <div
            v-if="hasSpecialOfferIndependent"
            column="xs-12 s-6">
            <special-offer-label
              :style="(isDiscountOptOut) ? { color: '#808080 !important' } : ''"
              :label="labels.specialOfferLabel"/>
          </div>
          <!-- <div
            v-if="covidSafe"
            column="xs-12 s-6">
            <span
              class="covid-safe-provider-label"
              :style="globalTheme.colorCovidSafe">
              <app-inline-svg
                :src="icons.covidSafeSvg.url"
                aria-label="map marker icon" />
              {{labels.covidCompliantToggle}}
            </span></div> -->
        </div>
      </div>
      <result-card-actions
        column="xs-12 s-12 m-6"
        class="action-column tablet-up"
        :labels="labels"
        :drawer-open="drawerOpen"
        :provider="provider"
        :has-special-offer="hasSpecialOffer"
        :has-special-offer-independent="hasSpecialOfferIndependent"
        :offers="offers"
        :offer-button-label="offerButtonLabel"
        :offer-popup-independent="offerPopupIndependent"
        :show-plus-provider-side-bar="showPlusProviderSideBar"
      />
      <div column>
        <provider-address
          :icon="icons.locationSvg.url"
          :provider="provider"
          show-provider-distance
          :label="labels.getDirections"
          :hide-link="true"
          class="flex-wrap directions-column">
        </provider-address>
        <provider-contact
          :provider="provider"
          :labels="labels"
          :view-details="viewDetails"
          :is-direction="false"
          class="flex-wrap contact-column">
        </provider-contact>
        <div
          v-if="legacyNetwork"
          >
          <p
            v-if="provider.locationEmailAddress"
            class="label email">
            <app-inline-svg
              :src="icons.emailSvg.url"
              :style="globalTheme.colorSecondary"/>
            <span class="hyphenate">{{provider.locationEmailAddress}}</span>
          </p>
        </div>
      </div>
      <provider-hours
        class="hours-column"
        :icon="icons.hoursSvg.url"
        :provider="provider"
        :label="labels.hours"
        :hours-unavailable-label="labels.hoursUnavailableMessage"
        :day-labels="dayLabels"
        :view-details="viewDetails"
        :show-plus-provider-side-bar="showPlusProviderSideBar"
        column="xs-12 s-12 m-6">
      </provider-hours>
    </div>
    <div
      grid="row wrap"
      class="_mta _mbxs mobile until-tablet">
      <result-card-actions
        column="xs-12 s-12"
        class="action-column"
        :labels="labels"
        :drawer-open="drawerOpen"
        :provider="provider"
        :has-special-offer="hasSpecialOffer"
        :has-special-offer-independent="hasSpecialOfferIndependent"
        :offers="offers"
        :offer-button-label="offerButtonLabel"
        :offer-popup-independent="offerPopupIndependent"
        :show-plus-provider-side-bar="showPlusProviderSideBar"
      />
    </div>
    <div
      grid="row wrap justify-between"
      class="_prxs _plxs">
      <directions-link 
        :provider="provider"
        :label="labels.getDirections" 
        class="hide-print _mtxs"
        :style-override="(isValidTierName || isDiscountOptOut) ? { color: '#808080 !important' } : globalTheme.buttonWhiteBordered"
      />
      <view-full-details-link
      v-if="!viewDetails"
      class="_mtxs "
      role="navigation"
      tabindex="0"
      :style-override="(isValidTierName || isDiscountOptOut) ? { color: '#808080 !important', border: '#808080 !important' } : globalTheme.buttonWhiteBordered"
      :provider="provider"
      :label="labels.detailsToggle"/>
    </div>
    <div grid="column wrap" v-if="viewDetails">
      <div
        v-if="provider.doctors.length || isConnecticut"
        column="xs-12 s-12"
        class="doctor-list">
        <div grid="row wrap">
          <div column="xs-12 s-12">
            <hr />
            <p class="label">
              <app-inline-svg
                :src="icons.providerSvg.url"
                :style="globalTheme.colorSecondary"/>
              <strong>{{labels.doctors}}</strong>
            </p>
            <div class="doctor-grid">
                <app-doctor
                  v-for="(doctor,i) in doctorList"
                  :key="i"
                  :hide-accept-new-patient="hideAcceptNewPatient"
                  :provider="provider"
                  :labels="doctorDetails"
                  :doctor="doctor"
                  :doctor-id="doctorIds[i]"
                  :is-open="expandedDoctorId === doctorIds[i]"
                  @toggle-doctor="handleDoctorToggle"/>
            </div>
          </div>
        </div>
      </div>
      <div
        :column="!provider.doctors.length ? 'xs-12 s-12' : 'xs-12 s-12'"
        class="extra-info">
        <hr/>
        <div grid="row wrap" class="mb-children">
          <provider-services
            column="xs-12 s-12 m-6"
            :icon="icons.servicesSvg.url"
            :provider="provider"
            :view-details="viewDetails"
            :label="labels.services"
          />
          <provider-products
            column="xs-12 s-12 m-6"
            :icon="icons.productsSvg.url"
            :provider="provider"
            :view-details="viewDetails"
            :label="labels.products"
          />
          <provider-brands
            column="xs-12 s-12 m-6"
            :icon="icons.brandsSvg.url"
            :provider="provider"
            :view-details="viewDetails"
            :label="labels.brands"
          />
          <provider-accessibility
            column="xs-12 s-12 m-6"
            :icon="icons.accessibilitySvg.url"
            :provider="provider"
            :unknownAccessibility="unknownAccessibility"
            :view-details="viewDetails"
            :label="labels.accessibility"
            :accessibility-details="labels.accessibilityDetails"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
   import {defineComponent} from 'vue'
  import { Provider, SearchResultCardLabels, DayLabels, ContentStackImage, Doctor, Option } from '@/types'
  import { mapState } from 'vuex'
  import { isTestContentLocation, csTestBaseUrl, csBaseUrl } from '@/site.config'
  import AppDoctor from '@molecules/Results/DoctorDrawer.vue'
  import ResultCardActions from '@molecules/Results/ResultCardActions.vue'
  import IsConnecticut from '@/mixins/IsConnecticut.ts'
  import ViewFullDetailsLink from '@atoms/ViewFullDetailsLink.vue'

  // function covidSafeCheck(provider: Provider): boolean {
  //   const complianceValue = provider.locationPreference.healthCompliant || provider.locationPreference.healthCompliant
  //   return complianceValue ? complianceValue.toLowerCase() === 'y' : false
  // }
  import { filterDoctorsListBySelectedValues } from '@/ts/helpers/search-providers.helpers.ts'
import DirectionsLink from '../../atoms/DirectionsLink.vue'
  export default defineComponent({
    components : {
      AppDoctor,
      ResultCardActions,
      ViewFullDetailsLink,
      DirectionsLink
    },
    mixins: [IsConnecticut],
    props: {
      legacyNetwork: {
        default: false,
        type: Boolean
      },
      provider: {
        required: true,
        type: Object as () => Provider
      },
      labels: {
        required: true,
        type: Object as () => SearchResultCardLabels
      },
      specialOffers: {
        type: Object as () => {}
      },
      offerButtonLabel: {
        type: String
      },
      offerPopupIndependent: {
        type: String
      },
      showPlusProviderSideBar: {
        default: false,
        type: Boolean
      },
      hideAcceptNewPatient: {
        default: false,
        type: Boolean
      },
      viewDetails: {
        default: false,
        type: Boolean
      },
      doctorDetails: {
        required: false,
        type: Object
      }
    },
    data() {
      return {
        address: this.provider.address,
        drawerOpen: false,
        wholesaleProviderColor: this.$store.state.globals.microsite.wholesaleProviderColor,
        noDiscountProviderColor: this.$store.state.globals.microsite.noDiscountProviderColor,
        offers: null,
        expandedDoctorId: null as string | null,
        // covidSafe: covidSafeCheck(this.provider) && this.$store.state.context.covidToggleOn
      }
    },
    computed: {
      doctorList(): Doctor[] {
        if (this.provider.doctorsFiltered) {
          return this.provider.doctorsFiltered
        } else {
          return this.provider.doctors
        }
      },
      ...mapState({
        icons: (state: any) => {
          return {
            ...state.globals.microsite.icons.searchResultCards,
            ...state.globals.microsite.icons.general
          }
        },
        dayLabels: (state: any) => state.globals.microsite.days as DayLabels,
        hideSpecialOfferByState: (state: any) => state.context.hideSpecialOfferByState as boolean
      }),
      icon(): string {
        const icons = this.$store.state.globals.microsite.icons
        const tieredIcon = icons.searchResultCards.tieredProviderSvg.url
        const defaultIcon = icons.mapMarkers.mapIconBasic.url
        return (this.provider as Provider).tieredLocation ? tieredIcon : defaultIcon
      },
      ariaLabel(): string {
        //@ts-ignore
        return this.drawerOpen ? `${this.labels.detailsToggleClose} for this ${this.provider.businessName}` : `${this.labels.detailsToggle} for this ${this.provider.businessName}`
      },
      isDiscountOptOut(): boolean {
        const locPreferences = this.provider.locationPreference
        return locPreferences.discountOptOut === 'true'
      },
      isValidTierName(): boolean {
        const tierName = this.provider.tierName
        return (tierName === 'Walmart' || tierName === 'Costco')
      },
      hasSpecialOffer(): boolean {
        if (this.hideSpecialOfferByState) return false
        let result = false
        const bandDescription = this.provider.bandDescription
        if (bandDescription && this.specialOffers && bandDescription in this.specialOffers) {
          const offers = this.specialOffers[bandDescription]
          if (offers) {
            result = true
            // eslint-disable-next-line
            this.offers = offers
          }
        }
        return result
      },
      hasSpecialOfferIndependent(): boolean {
        if (this.hideSpecialOfferByState) return false
        const locPreference = this.provider.locationPreference
        return locPreference.specialOfferIndicator
      },
      unknownAccessibility(): boolean {
        return this.doctorList.length === 0 && this.provider.disabilityAccomodations.length === 0;
      },
      doctorIds() {
        return this.doctorList.map(doctor => 
          `${doctor.firstName || ''}${doctor.providerId || ''}${doctor.middleName || ''}`
        );
      },
    },
    methods: {
      setCurrentProvider(): void {
        this.$emit('setCurrentProvider')
      },
      brandLogo() {
        let finalBrandLogoUrl
        const allLogos: Object = this.$store.state.brandLogos.brandLogos
        const businessName: string = this.provider.businessName ? this.provider.businessName.toLowerCase() : ''
        const locationLogo: string = this.provider.locationPreference.locationLogo ? this.provider.locationPreference.locationLogo.toLowerCase() : ''
        const matchingBrand: string|undefined = Object.keys(allLogos).find(key => {
          return  (locationLogo && locationLogo.includes(key) || businessName === key) ? key : undefined
        })
        if (locationLogo && locationLogo.startsWith('emcontent')) {
          const brandLogoPath = locationLogo.split('/').pop()
          finalBrandLogoUrl = isTestContentLocation ? `${csTestBaseUrl}/assets/member/${brandLogoPath}` : `${csBaseUrl}/assets/member/${brandLogoPath}`
        }
        else if (matchingBrand) {
          finalBrandLogoUrl = allLogos[matchingBrand].url
        }
        return finalBrandLogoUrl
      },
      handleDoctorToggle(doctorId: string): void {
        if (this.expandedDoctorId === doctorId) {
          this.expandedDoctorId = null
        } else {
          this.expandedDoctorId = doctorId
        }
      }
    }
  })
</script>
<style>
.hyphenate {
  overflow-wrap: break-word;
  word-wrap: break-word;
  word-break: break-all;
  word-break: break-word;
  hyphens: auto;
}

.mb-children > * {
  margin-bottom: 1.5rem;
}

.offers-tag > * {
  max-width: fit-content !important;
}

.doctor-grid {
  display: grid;
  grid-template-columns: repeat(1, 1fr); 
  gap: 0.5rem; 
}

@media (min-width: 500px) {
  .doctor-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}
@media (min-width: 768px) {
  .doctor-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}
</style>
